import React, { FC, FormEvent, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setSuccess } from "../../../store/actions/userActions";
import { RootState } from "../../../store";

import Header from "../../sections/Header";
import Company from "../admin/CompanyInformation";
import Service from "../admin/Service";
import Theme from "../admin/Theme";

import { Itheme } from "../../../entities/Theme";
import { ICompany } from "../../../entities/Company";
import { datac } from "../../../entities/Datav1";
import { servicesv1, SlotTypev1 } from "../../../entities/Datav1";

import { companyv2 } from "../../../entities/Datav2";

import { Link, useHistory } from "react-router-dom";

import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";
import { getRequestParams, service } from "../../../tools/service";

import UploadImage from "../../../assets/images/upload/upload img.png";

import { clean } from "./Edit";

import GoogleAnalyticsConfiguration from "../../../googleAnalytics/googleAnalyticsConfiguration";

export interface IMainForm {
  company: ICompany;
  themes: Itheme;
  services?: servicesv1;
}

/**
 *  This file handle the creating of new company
 * @returns  
 */
const CreateWidget: FC = () => {
  const { success } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [values, setValues] = useState<string[]>([]);
  const [datav1, setDatav1] = useState<datac>();

  const [imgUploaded, setImagUpload] = useState(UploadImage ?? "")

  //change when s3 bucket is running
  const [file, setFile] = useState<string>();
  const [base64, setBase64] = useState<any>();
  //end change when s3 bucket is running

  const [editServiceCurrent, setEditServiceCurrent] = useState([])
  const [errors,setErrors] = useState({})
  const [form, setForm] = useState<IMainForm>({
    company: {
      name: "",
      streetAddress: "",
      place: "",
      city: "",
      state: "",
      zipCode: "",
      img: "",
      successwareCompanyId: ""
    },
    themes: {
      primaryColor: "",
      secondaryColor: "",
      iconColor: "",
      primaryFont: "",
      primaryFontColor: "",
      secondaryFontColor: ""
    }
  })

  const [formv2, setFormv2] = useState<companyv2>();
  let history = useHistory();
  useEffect(() => {
    GoogleAnalyticsConfiguration.sendPageView("Create Widget");
    if (success) {
      dispatch(setSuccess(''));
    }
  }, [success, dispatch, form, editServiceCurrent, imgUploaded,errors]);

  const getBase64 = (file: any) => {
    return new Promise(resolve => {
      let fileInfo;
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        let baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleOnChange = React.useCallback(
    (formToEdit: keyof IMainForm, prop: string, value: any) => {
      const handleError = {... errors} as { [key: string]: any }
      const newFormToEdit = { ...form[formToEdit] } as { [key: string]: any }
      //change when s3 bucket works
      if (prop === 'img') {
        let file = value[0];
        getBase64(file)
          .then(result => {
            file["base64"] = result;
            setBase64(result)
            setFile(file)
            newFormToEdit[prop] = result;
            setImagUpload(result as any)
            showNotification("Image", "Image uploaded successfully", "success")
          })
          .catch(err => {
            console.log(err);
          });
      }else if(prop === 'state'){ 
        newFormToEdit[prop] =  value.toUpperCase().replace(/[^A-Za-z]/ig, '');
      }else{
        newFormToEdit[prop] = value;
      }
      handleError[prop] = 0;
      setErrors(handleError);
      //end change when s3 bucket works
      setForm({
        ...form,
        [formToEdit]: newFormToEdit,
      })
      if (prop === "successwareCompanyId") {
        localStorage.removeItem("slotTypes")
        setEditServiceCurrent([])
        localStorage.setItem("currentCompanySelected", value as string)
      }
    },
    [form]
  )

  const showNotification = (title: string, message: string, type: any) => {
    store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true
      }
    });
  }

  /**
   * This method validate the form data before send 
   * @param countForm  
   * @param services 
   * @returns 
   */
  function formValidation(countForm: IMainForm, services: any): boolean {
    let allowCompany = true;
    if (countForm.company.city.length === 0 || countForm.company.name.length === 0 || 
       countForm.company.streetAddress.length === 0
      || countForm.company.state.length === 0 || countForm.company.zipCode.length === 0 || 
      countForm.company.img.length === 0 || services.length === 0 || countForm.themes.iconColor.length === 0 ||
      countForm.themes.primaryColor.length === 0 || countForm.themes.primaryFont.length === 0
      || countForm.themes.secondaryColor.length === 0 || countForm.themes.primaryFontColor.length === 0 ||
      countForm.themes.secondaryFontColor.length === 0) allowCompany = false;
    return allowCompany;
  }


  /**
   * This method handle the 
   * @param e
   */
  const handleCreateNewCompany = (e: FormEvent) => {
    e.preventDefault()
    const services = JSON.parse(localStorage.getItem('service') || '[]')
    const temp = { ...form }
    temp.services = services;
    const tempData = { ...datav1 }
    const openService = JSON.parse(localStorage.getItem('openService') || "0")
    if( services.lenght > 0 ){
      const handleError = {... errors} as { [key: string]: any }
      handleError["slotTypes"] = 0;
      setErrors(handleError);
    }
    

    if (formValidation(temp,services)  && openService === 0) {

      tempData.name = temp.company.name
      tempData.streetAddress = temp.company.streetAddress
      tempData.place = temp.company.place
      tempData.city = temp.company.city
      tempData.state = temp.company.state
      tempData.zipCode = temp.company.zipCode
      tempData.img = temp.company.img
      tempData.successwareCompanyId = localStorage.getItem("currentCompanySelected") as string

      const serviceConfigReady = JSON.parse(localStorage.getItem('service') || '[]') as any[];

      const newService: servicesv1[] = serviceConfigReady?.reduce((items, it) => {

        const slotTypes: SlotTypev1[] = it.slotTypes?.reduce((stypes: any, st: any) => {
          stypes.push({
            slotType: st.slotType,
            slotFriendlyName: ((st.slotFriendlyName.value && st.slotFriendlyName.value.length > 0) ? st.slotFriendlyName.value : st.slotType) ?? "",
            jobTypes: st.jobTypes.map((val: any) => ({
              groupName: val.groupName,
              jobClass: val.jobClass,
              jobType: val.jobType,
              jobTypeDesc: val.jobTypeDesc,
              jobFriendlyName: (val.jobFriendlyName.value && val.jobFriendlyName.value.length > 0 ? val.jobFriendlyName.value : val.jobTypeDesc) ?? ""
            }))
          })
          return stypes
        }, [] as SlotTypev1[])
        items.push({
          serviceType: it.serviceType,
          serviceFriendlyName: (it.serviceFriendlyName.value && it.serviceFriendlyName.value.length > 0) ? it.serviceFriendlyName.value : it.serviceType,
          slotTypes
        })

        return items
      }, [] as servicesv1[])

      //services[]
      tempData.services = newService //JSON.parse(localStorage.getItem('service') || '[]');

      //themes[]
      tempData.themes = new Array(temp.themes)

      //format new payload
      const userInfo = getRequestParams() as any
      const payload = { ...formv2 }
      payload.userName = userInfo["userName"]
      payload.companies = new Array(tempData as datac);

  

      const url = "api/widgets"
      let urlImg = "";
      let payloadImg = {} as any
      payloadImg["image"] = temp.company.img
      let widgetId = ""
      let companyInfo = [] as any;
      console.log("handleCreateNewCompany payload " + payload );
      service.post(url, payload)
        .then(response => {
          localStorage.removeItem('service')
          localStorage.removeItem('multi-service')
          widgetId = response.data.id;
          companyInfo = response.data.companies.filter((val: any) => {
            return val.name === temp.company.name;
          })

          urlImg = `/api/widgets/${widgetId}/company/${companyInfo[0].id}/logo`;
        }).then(() => {
          service.post(urlImg, payloadImg)
            .then(() => {
              history.push(`/admin/widget/success?widgetId=${widgetId}&companyId=${companyInfo[0].id}`)
            }).catch(errorImg => {
              showNotification("Widget", "Error, img was not sent", "danger")
            })
        })
        .catch(error => {
          console.log(error);
        });


    } else {
      const handleError = {... errors} as { [key: string]: any }
      const imgText = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAKKADAAQAAAABAAAAKAAAAABZLkSWAAACw0lEQVRYCe2YXW7TQBCAZ920CILUcILmBqTPtCK+ATzSItEjhBv0BukNKBLpMzewoYXXJjfoDQhS04c2eJhxs+nuyuuMYyvOQ/YhOzu7nvk8s38OwKZsIrCJQG4ElNl79CvqqERFoKBl6lcmI4wxwPDiTTjUPgMtcK0QerXBpQDQShkMKAsQEdpGXy2iy9DwU+DIfRv/2HI9qOCM8vc6y4oXkN5kPDgM46yHqtYdXUZjZa2GJw9Wip/U6yN5I+hD5JWOamv32fN/o/P9cOwbV5VeHMGT66h1fBVHCtV1kCTxw0T9Ob6KelWB+OyIAe/v4JSMdG1Dqv/xMnJ09oiyLTEgbeCfspwlAbzL0lelE89BpNwq2sWlJT2VUPW3m/i+zFwVR5DYzrPgggS+u/r5kUlT4n6iIp6/7hhpWwy48wJOEfGHbRg/f3P2yjnc7DynmHfKQIoBOU0Xh2GXUr2vEENK3avBQXhmArtwuq8MpHgOamfmTUPruM6CQ8C/NG93ud+ADIvMSXEE2YmvZMEB4NedJrSpHunnGHJ6Cx3dltSFI+ga9cFR+k94LC2Q7sMEY99lgMdAAENMMBVZfhQef0sBLoJjF5zORZA0bXomlCkvnWIJnHbEkNtN6Jrp1n2L6qUAi8BpAA05bcCN1knqwileBk6DzFbvWLf5HKfzKdLtwUGX1pFdCkWwDJztVt4SA9YBx68hAqwLTgRYJxwD5i6SKuHcBcHOZ1szi2mhG7urygFUak8lYP3LQE8PMdj68uH3z7faaF5dxXeLN4K03tt8wpuFmvTXSBKbujyZzt2Q+sXjs2xZgHRlvqFBouhkGcvTNV7CcHqLDDwv9MFOFwfV1wq+xmlZ1xZg+oWPSLul2tMDqqpnm3Rs2qN5CeRzXtzLL3dYgLO7Xnv+xBoIon2wTs61B7RSvOpIZS2cVTOU9vcfM2Irp/MktRQAAAAASUVORK5CYII=";
    
    
      if(temp.company.successwareCompanyId.length === 0){
        showNotification("Widget", "Error, you have to choose a company", "warning")
        handleError["id"] = 1;
        setErrors(handleError)
      }else if(temp.company.name.length === 0){
        showNotification("Widget", "Error, company name can't be empty", "warning")
        handleError["name"] = 1;
        setErrors(handleError)
      }else if(temp.company.streetAddress.length === 0){
        showNotification("Widget", "Error, Street Address can't be empty", "warning")
        handleError["streetAddress"] = 1;
        setErrors(handleError)
      }else if(temp.company.city.length === 0){
        showNotification("Widget", "Error, City can't be empty", "warning")
        handleError["city"] = 1;
        setErrors(handleError)
      }else if(temp.company.state.length === 0){
        showNotification("Widget", "Error, State can't be empty", "warning")
        handleError["state"] = 1;
        setErrors(handleError)
      }else if(temp.company.zipCode.length === 0){
        showNotification("Widget", "Error, ZipCode can't be empty", "warning")
        handleError["zipcode"] = 1;
        setErrors(handleError)
      }else if( (temp.company.img.length === 0 && imgUploaded.length === 0) || imgUploaded === imgText){
        showNotification("Widget", "Error, Logo can't be empty", "warning")
        handleError["img"] = 1;
        setErrors(handleError)
       }else if( services.length === 0 || openService === 1){
        if(openService === 0)
          showNotification("Widget", "Error, You have to add a service", "warning")
        showNotification("Service","You must add at least one service","warning")
        handleError["slotTypes"] = 1;
        setErrors(handleError)
      }else if( temp.themes.primaryColor.length === 0 ){
        showNotification("Widget", "Error, Primary Color can't be empty", "warning")
        handleError["primaryColor"] = 1;
        setErrors(handleError)
      }else if( temp.themes.secondaryColor.length === 0 ){
        showNotification("Widget", "Error, Secondary Color can't be empty", "warning")
        handleError["secondaryColor"] = 1;
        setErrors(handleError)
      }else if( temp.themes.iconColor.length === 0 ){
        showNotification("Widget", "Error, Icon Color can't be empty", "warning")
        handleError["iconColor"] = 1;
        setErrors(handleError)
      }else if( temp.themes.primaryFontColor.length === 0 ){
        showNotification("Widget", "Error, Primary Font Color can't be empty", "warning")
        handleError["primaryFontColor"] = 1;
        setErrors(handleError)
      }else if( temp.themes.secondaryFontColor.length === 0 ){
        showNotification("Widget", "Error, Secondary Font Color can't be empty", "warning")
        handleError["secondaryFontColor"] = 1;
        setErrors(handleError)
      }else if( temp.themes.primaryFont.length === 0 ){
        showNotification("Widget", "Error, Primary Font can't be empty", "warning")
        handleError["primaryFont"] = 1;
        setErrors(handleError)
      }
    }
  }
  

  return (
    <>
      <ReactNotification />
      <Header />
      <div className="h-full w-full  bg-customGray flex flex-col">
        <h1 className="text-3xl text-customBlue custom-title-successware mx-auto mt-10 mb-6 " >Create Booking Widget</h1>
        <form action="" onSubmit={handleCreateNewCompany}>
          <Company 
            data={form.company} 
            onChange={(prop, value) => handleOnChange("company", prop, value)} 
            imgUploaded={imgUploaded} 
            errors = { errors }
          />
          <hr className="divider w-3/4 mx-auto" />
          <Service 
            values={values} 
            onChange={setValues} 
            editInfoService={editServiceCurrent} 
            errors = {errors} 
            serverDataReady={true}
            />
          <hr className="divider w-3/4 mx-auto" />
          <Theme data={form.themes} onChange={(prop, value) => handleOnChange("themes", prop, value)} errors = { errors } />
          <hr className="divider w-3/4 mx-auto" />
          <div className="m-3 flex flex-col w-1/2 mx-auto my-auto  pb-4 pt-4 md:flex-row md:justify-end md:w-3/4 max-w-6xl">
            <Link to={`/admin/widget`}>
              <button
                onClick={() => clean()}
                className="font-bold text-customBlue custom-btn-preview-widget mb-3 md:mb-0 md:mr-5"
              >Cancel Widget</button>
            </Link>
            <button
              className="font-bold text-customBlue custom-btn-add-service"
            >Create Widget</button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CreateWidget;
